import React, { useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import "./ProjectModal.css";

function ProjectModal({ show, handleClose, mode = "edit" }) {
  const [projectName, setProjectName] = useState("Profcyma Career Solutions");

  const [description, setDescription] = useState(
    "Profcyma Career Solutions is an EdTech career platform built for working professionals who want to grow without putting their careers on pause. We bridge the gap between ambition and opportunity by guiding learners toward the right online degrees and career pathways from India's top universities. With a focus on clarity, credibility, and career outcomes, Profcyma empowers professionals to upskill with confidence and make informed decisions that shape their future."
  );

  const [projectUrl, setProjectUrl] = useState("https://profcyma.com/");

  const handleSave = () => {
    console.log({
      projectName,
      description,
      projectUrl,
    });

    handleClose();
  };

  const handleDelete = () => {
    console.log("Delete Project");
    handleClose();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="lg"
      dialogClassName="common-modal project-modal"
    >
      <Modal.Header className="project-modal__header">
        <Modal.Title>
          <Button
            variant="link"
            className="we-back-btn p-0 me-2"
            onClick={handleClose}
          >
            <FontAwesomeIcon icon={faAngleLeft} />
          </Button>

          {mode === "add" ? "Add Project" : "Edit Project"}
        </Modal.Title>

        <button
          className="btn-close"
          onClick={handleClose}
        ></button>
      </Modal.Header>

      <Modal.Body className="project-modal__body">
        {/* Project Name */}

        <Form.Group className="mb-4">
          <Form.Label className="project-modal__label">
            Project Name <span className="text-danger">*</span>
          </Form.Label>

          <Form.Control
            className="project-modal__input"
            value={projectName}
            onChange={(e) => setProjectName(e.target.value)}
          />
        </Form.Group>

        {/* Description */}

        <Form.Group className="mb-4">
          <Form.Label className="project-modal__label">
            Project Description <span className="text-danger">*</span>
          </Form.Label>

          <Form.Control
            as="textarea"
            rows={6}
            maxLength={2000}
            className="project-modal__textarea"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Enter project description"
          />

          <div className="project-modal__count">
            {description.length}/2000 characters
          </div>
        </Form.Group>

        {/* URL */}

        <Form.Group>
          <Form.Label className="project-modal__label">
            Project URL
          </Form.Label>

          <Form.Control
            className="project-modal__input"
            placeholder="https://example.com"
            value={projectUrl}
            onChange={(e) => setProjectUrl(e.target.value)}
          />
        </Form.Group>
      </Modal.Body>

      <Modal.Footer className="project-modal__footer">
        {mode === "edit" ? (
          <Button
            variant="link"
            className="project-modal__delete"
            onClick={handleDelete}
          >
            Delete Project
          </Button>
        ) : (
          <div />
        )}

        <Button
          className="project-modal__save"
          onClick={handleSave}
        >
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ProjectModal;